import { render, staticRenderFns } from "./MarkerDataTable.vue?vue&type=template&id=58f883ce&scoped=true"
import script from "./MarkerDataTable.vue?vue&type=script&lang=js"
export * from "./MarkerDataTable.vue?vue&type=script&lang=js"
import style0 from "./MarkerDataTable.vue?vue&type=style&index=0&id=58f883ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f883ce",
  null
  
)

export default component.exports